import styled from 'styled-components';
import { Box, Card } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';

const StyledContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: white;
    overflow: auto;
`;

const StyledHomeIcon = styled(HomeIcon)`
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    
    &:hover {
        color: #1565c0;
        transform: scale(1.1);
    }
    
    &:active {
        transform: scale(0.95);
    }
`;

const StyledCard = styled(Card)`
  max-width: 600px;
  margin: 0 auto;
  overflow: hidden;
`;
const StyledHeader = styled(Box)`
  background-color: white;
  padding: 24px;
  color: var(--secondary-main);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledContent = styled(Box)`
  padding: 24px;
`;
const EliteTag = styled(Box)`
  background-color: #ff9800;
  color: white;
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
`;
const StatCard = styled(Card)`
  background-color: #f5f5f5;
`;
const AffiliateCodeContainer = styled(Box)`
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 8px;
`;

const AffiliateCode = styled.code`
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  color: var(--light-green);
  font-family: monospace;
  font-size: 1.125rem;
  &:hover {
    color: var(--light-green-hover);
`;

export { StyledContainer, StyledCard, StyledHeader, StyledContent, EliteTag, StatCard, AffiliateCodeContainer, AffiliateCode, StyledHomeIcon };